// extracted by mini-css-extract-plugin
export default {"loader":"catalog-loader-module__loader","ds-bounce":"catalog-loader-module__ds-bounce","ds-spin":"catalog-loader-module__ds-spin"};